import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import {Client} from '../client';
import {ClientFicheDienst} from '../client-fiche';
import {DialogService} from '../../core/dialog/dialog.service';

@Component({
    selector: 'zah-client-fiche',
    templateUrl: './client-fiche.component.html',
    styleUrls: ['./client-fiche.component.scss'],
    providers: [],
    standalone: false
})
export class ClientFicheComponent implements OnInit {
  private dialogService = inject(DialogService);

  @Input()
  client: Client;
  @Output()
  clientMeldingAdded: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  backButtonClicked: EventEmitter<void> = new EventEmitter<void>();

  andereDiensten: Array<ClientFicheDienst>

  ngOnInit(): void {
    this.andereDiensten = this.client.getFiche()?.getAndereDiensten() || []
  }

  onBackButtonClicked(): void {
    this.backButtonClicked.emit();
  }

  onWijzigingMeldenClick() {
    this.dialogService
      .askText({
        label: 'Nieuwe cliëntfiche melding',
        placeholder: 'Voer een nieuwe cliëntfiche melding in',
        confirmLabel: 'Bewaar',
      })
      .subscribe(melding => this.clientMeldingAdded.emit('Cliëntfiche: ' + melding))
  }
}
